import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store';
import { setImportModalOpen } from 'store/slices/importSlice';
import ImportCardsModal from 'components/ImportCardsModal/ImportCardsModal';

/**
 * Renders ImportCardsModal globally when triggered from the nav pill.
 * Shows in "status mode" — progress/results only, not input UI.
 * Placed at the app root level so it's accessible from any page.
 */
export const ImportModalManager = () => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector((state: RootState) => state.import.isModalOpen);
  const targetList = useSelector((state: RootState) => state.import.job.targetList);

  if (!isModalOpen) return null;

  return (
    <ImportCardsModal
      isOpen={isModalOpen}
      onClose={() => dispatch(setImportModalOpen(false))}
      onCardAdd={() => {}}
      isHaveList={targetList === 'have'}
      statusMode={true}
    />
  );
};

export default ImportModalManager;
